//非同期バリデート
export default function checkValid(form_id, elem, alert_on = true) {
    const form = document.getElementById(form_id);
    const fd = new FormData(form);
    const lang = document.documentElement.lang;
    //二重送信防止
    $(elem).attr('disabled', true);
    $.ajax({
        type: "POST",
        url: elem.dataset.url,
        data: fd,
        processData: false,
        contentType: false
    }).done((res) => {
        if (res == true) {
            $(form).trigger("submit");
        }
        if (Object.keys(res).length > 0) {
            $(elem).attr('disabled', false);
            if ( alert_on === true ){
                if ( lang === 'en'){
                    alert('There is an error, please check.');
                }else{
                    alert('エラーがあります。確認してください');
                }
            }
            $(".c-errorMsg").text(null);
            $("input, textarea, select").removeClass("c-errorBg");
            $.each(res, function(key, val) {

                var name  = `[name="${key}"]`;
                $(name).addClass("c-errorBg");
                $(name).next(".c-errorMsg").append(`<span>${val}</span>`);
            });
        }
    }).fail(() => {
        $(elem).attr('disabled', false);
        if ( lang === 'en' ){
            alert("communication failed.")
        }else{
            alert("通信に失敗しました");
        }
    });
}

//二重送信防止
$(function () {
    $('.prev_double_send').on("submit", function () {
        $(this).find(':submit').prop('disabled', true);
    });
});

//iOS safariキャッシュ対策
window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      // bfcache発動時の処理
      $(".bfcache_flg").prop('disabled', false);
    }
});

//保存時のフラッシュメッセージ
setTimeout(function() {
    $(".c-alert--success,.c-alert--error")
        .fadeOut(2000)
        .queue(function() {
            this.remove();
        });
}, 1000);

$(window).on('load', function() {
    $(function(){
        if (window.matchMedia("(min-width: 961px)").matches){
            $(".js-category-menu").mouseover(function(){
                $(this).find(".l-headerSubListDetailMenu").stop().slideDown();
                $(".l-headerSub").css('z-index', '500000');
            });
            $(".js-category-menu").mouseout(function(){
                $(this).find(".l-headerSubListDetailMenu").stop().slideUp();
                $(".l-headerSub").css('z-index', '100000');
            });
            $(".l-headerSubList").mouseover(function(){
                $(".l-mainModal").stop().fadeIn(500);
                $(".l-headerSub").css('z-index', '500000');
            });
            $(".l-headerSubList").mouseout(function(){
                $(".l-mainModal").stop().fadeOut(500);
                $(".l-headerSub").css('z-index', '100000');
            });
        }
    });
});

if (window.matchMedia("(max-width: 960px)").matches){
    $(".js-category-menu").click(function() {
        $(this).find(".l-headerSubListDetailMenu").stop().slideToggle();
        $(this).find(".l-headerSubListItem__name").toggleClass("active");
        $(".l-mainModal").fadeToggle(500);
    });
    $(".js-headerBtn").click(function() {
        $(".l-headerSub").slideToggle();
        $(".l-headerSub").css('z-index', '500000');
    });
}

//ページトップへ戻るボタン
$(function(){
    var pagetop = $('#js-pagetop');
    pagetop.hide();
        $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
    pagetop.click(function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
    });
});
$(function(){
$('.c-tableTtl__main').css('font-size', '10px');

$('.js-modal-button').on('click',function(){
    console.log('test');
    $('.l-footer__btnTop').css('z-index', 1000);
});
});

// モーダル出たら上へボタン見えなくする

// $(document).ready(function(){
//     var $footer = $('footer');
//     if(window.innerHeight > $footer.offset().top + $footer.outerHeight() ) {
//         $footer.attr({'style': 'position:absolute; bottom:0;'});
//         // $('#app').attr({'style':'padding-bottom:' + ($footer.outerHeight()) + 'px;'});
//     }
// })
